import React, { useEffect, useState } from 'react'
import { useTranslation } from '../../hooks/useTranslation'
import {
  BackIcon,
  ForwardIcon,
  CompleteIcon,
} from './TrackTileComponents/icons'
import { useIsDesktop, useMediaQueryScreen } from '../../hooks/useMediaQuery'

const StepMenu = ({ activeTab, setActiveTab, totalSteps }) => {
  const { t } = useTranslation()
  const [totalStepsToShow, setTotalStepsToShow] = useState([])
  const isDesktop = useIsDesktop()
  const isXlScreen = useMediaQueryScreen('xl')

  const getSectionTitle = (sectionName) => {
    const parts = sectionName?.split('_')
    if (parts) {
      if (parts.length === 3 && parts[2] === 'plus') {
        return `${t(parts[0])} ${parts[1]}+`
      } else if (parts.length === 3 && parts[0] === 'months') {
        return `${t('months')} ${parts[1]} - ${parts[2]}`
      } else if (parts.length === 3 && parts[0] === 'weeks') {
        return `${t('weeks')} ${parts[1]} - ${parts[2]}`
      } else {
        return t(`${parts[0]}_indicator`, {
          number: parts[1],
        })
      }
    }
  }

  const completed = (step) => {
    const completedSubsections = Object.values(step)[0]['subsections'].filter(
      (subsection) => subsection.completed || subsection.skipped,
    )
    return (
      completedSubsections.length ===
      Object.values(step)[0]['subsections'].length
    )
  }

  const viewableSteps = isDesktop ? (isXlScreen ? 6 : 3) : 2

  useEffect(() => {
    if (totalSteps.length === 0) return
    const currentTabName = Object.keys(activeTab || {})[0]
    const currentTabIndex = totalSteps.findIndex(
      (step) => Object.keys(step)[0] === currentTabName,
    )
    if (currentTabIndex !== -1 && totalSteps[currentTabIndex] === activeTab) {
      return
    }
    const firstIncompleteStep = totalSteps.findIndex((step) => !completed(step))
    const currentStep =
      firstIncompleteStep === -1 ? totalSteps.length - 1 : firstIncompleteStep
    const justCompletedActiveStep =
      currentTabIndex !== -1 &&
      !completed(activeTab) &&
      completed(totalSteps[currentTabIndex])
    const focusIndex =
      currentTabIndex === -1 || justCompletedActiveStep
        ? currentStep
        : currentTabIndex
    const start = Math.max(
      0,
      Math.min(focusIndex - 1, totalSteps.length - viewableSteps),
    )
    setTotalStepsToShow(totalSteps.slice(start, start + viewableSteps))
    setActiveTab(totalSteps[focusIndex])
  }, [totalSteps, setActiveTab, activeTab, viewableSteps])

  const shiftLeft = () => {
    const firstStep = totalStepsToShow[0]
    const firstStepIndex = totalSteps.findIndex((step) => step === firstStep)
    if (firstStepIndex > 0) {
      setTotalStepsToShow(
        totalSteps.slice(
          firstStepIndex - 1,
          firstStepIndex + viewableSteps - 1,
        ),
      )
    }
  }

  const shiftRight = () => {
    const firstStep = totalStepsToShow[0]
    const firstStepIndex = totalSteps.findIndex((step) => step === firstStep)
    if (firstStepIndex + viewableSteps - 1 < totalSteps.length - 1) {
      setTotalStepsToShow(
        totalSteps.slice(
          firstStepIndex + 1,
          firstStepIndex + viewableSteps + 1,
        ),
      )
    }
  }

  return (
    <div className="relative w-full overflow-x-scroll border-b border-solid border-[#979797] sm:static sm:overflow-auto">
      <div className="m-auto flex w-10/12 flex-row items-center justify-between gap-5">
        {totalStepsToShow.length > 0 && (
          <div
            onClick={shiftLeft}
            className="cursor-pointer pt-4"
            style={{ userSelect: 'none' }}
          >
            <BackIcon />
          </div>
        )}
        {totalStepsToShow.map((step, index) => (
          <div
            key={`${Object.keys(step)[0]}_${index}}`}
            onClick={() => setActiveTab(step)}
            className={
              activeTab === step
                ? 'boder-solid flex cursor-pointer flex-col items-center justify-center gap-2 border-b-4 border-[#08467C] text-center font-roboto-slab text-xl font-medium'
                : 'flex cursor-pointer flex-col items-center justify-center gap-2 pb-[.25rem] text-center font-roboto-slab text-xl font-medium'
            }
          >
            {completed(step) ? <CompleteIcon /> : <div className="h-6 w-6" />}
            <div
              className={`px-4 pb-4 ${
                completed(step) ? 'text-intoo-green-coachcta' : 'text-primary'
              }`}
            >
              {Object.keys(step)[0] && getSectionTitle(Object.keys(step)[0])}
            </div>
          </div>
        ))}
        {totalStepsToShow.length > 0 && (
          <div
            onClick={shiftRight}
            className="cursor-pointer pt-4"
            style={{ userSelect: 'none' }}
          >
            <ForwardIcon />
          </div>
        )}
      </div>
    </div>
  )
}

export default StepMenu
